import { render } from "./parallax_star.vue?vue&type=template&id=fff2bd1c"
import script from "./parallax_star.vue?vue&type=script&lang=js"
export * from "./parallax_star.vue?vue&type=script&lang=js"

import "./parallax_star.vue?vue&type=style&index=0&id=fff2bd1c&lang=sass"
script.render = render

export default script